import vSelect from 'vue-select'
// import Input from './../views/form/Input'
// import InputSearch from './../views/form/InputSearch.vue'
// import InputDrop from './../views/form/InputDrop.vue'
// import TextAria from './../views/form/TextAria.vue'
// import SearchTextAria from './../views/form/SearchTextAria.vue'
//
// import Th from './../views/form/Th.vue'
// import Option from './../views/form/Option.vue'
// import OptionSearch from './../views/form/OptionSearch.vue'
// import Submit from './../views/form/Submit.vue'
// import Update from './../views/form/Update.vue'
// import SearchButton from './../views/form/SearchButton.vue'
// import ViewList from './../views/modal/ViewList.vue'
import Loader from './../views/modal/Loader'
import DivLoader from './../views/modal/DivLoader'
import Notification from './../views/modal/Notification'
// import DeleteModal from './../views/modal/DeleteModal.vue'
// import Paginate from './../views/form/PaginateForm.vue'
// import Popup from './../views/modal/Popup.vue'
import postPopup from './../views/modal/postPopup.vue'
// import MessagePopup from './../views/modal/MessagePopup.vue'
// import ServerModal from './../views/modal/ServerModal.vue'
// import ConfirmModal from './../views/modal/ConfirmModal.vue'
// import ApprovalModal from './../views/modal/ApprovalModal.vue'
// import RejectModal from './../views/modal/RejectModal.vue'
// import ApproveModal from './../views/modal/ApproveModal.vue'
// import CancelModal from './../views/modal/CancelModal.vue'
// import PostPopup2 from './../views/modal/PostPopup2'



// const app = createApp(App);
// component("vSelect", vSelect)
//     .component("Input", Input)
//     .component("InputSearch", InputSearch)
//     .component("Th", Th)
//     .component("Option", Option)
//     .component("OptionSearch", OptionSearch)
//     .component("Submit", Submit)
//     .component("SearchButton", SearchButton)
//     .component("ViewList", ViewList)
//     .component("Loader", Loader)
//     .component("Notification", Notification)
//     .component("DeleteModal", DeleteModal)
//     .component("Paginate", Paginate)
//     .component("Popup", Popup)

export default {
    "vSelect": vSelect,
    // "Input": Input,
    // "InputSearch": InputSearch,
    // "Th": Th,
    // "Option": Option,
    // "OptionSearch": OptionSearch,
    // "Submit": Submit,
    // "SearchButton": SearchButton,
    // "ViewList": ViewList,
    "Loader": Loader,
    "Notification": Notification,
    // "DeleteModal": DeleteModal,
    // "Paginate": Paginate,
    // "Popup": Popup,
    "postPopup": postPopup,
    // "MessagePopup": MessagePopup,
    // "ServerModal": ServerModal,
    // "TextAria": TextAria,
    // "SearchTextAria": SearchTextAria,
    // "InputDrop": InputDrop,
    // "ConfirmModal": ConfirmModal,
    // "ApprovalModal": ApprovalModal,
    // "CancelModal": CancelModal,
    // "RejectModal": RejectModal,
    // "ApproveModal": ApproveModal,
    // "PostPopup2": PostPopup2,
    "DivLoader": DivLoader,
    // "Update": Update
}